import type { CarpetPricingCatalogItem, CarpetPricingCatalogCreate } from '@jobos/shared';
import { createRateCardHooks } from './createRateCardHooks';

const {
  queryKeys: carpetCatalogKeys,
  useRates: useCarpetCatalog,
  useAddRate: useAddCarpetCatalogItem,
  useUpdateRate: useUpdateCarpetCatalogItem,
  useDeleteRate: useDeleteCarpetCatalogItem,
} = createRateCardHooks<CarpetPricingCatalogItem, CarpetPricingCatalogCreate>({
  resource: 'carpet-catalog',
  entityName: 'carpet catalog item',
});

export {
  carpetCatalogKeys,
  useCarpetCatalog,
  useAddCarpetCatalogItem,
  useUpdateCarpetCatalogItem,
  useDeleteCarpetCatalogItem,
};
